export class UpdateCredentialsProfileInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetServiceAccountEmail",
            "baseName": "targetServiceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCredentialsProfileInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
